<template>
  <div>
    <div class="page-title">編輯訂單</div>
    <div class="page-box">
      <vue-dividing-line title="基本信息"></vue-dividing-line>
      <el-row class="row-list" :gutter="20">
        <el-col :span="12"> 訂單編號 : {{ detail.orderNo }}</el-col>
        <el-col :span="12"
          >用戶電郵 : {{ detail.createdAt | formatDate }}
        </el-col>
      </el-row>
      <el-row class="row-list" :gutter="20">
        <el-col :span="12">
          訂單日期 : {{ detail.createdAt | formatDate }}</el-col
        >
        <el-col :span="12">訂單金額 : {{ detail.totalPrice }}</el-col>
      </el-row>
      <el-form label-position="top" label-width="80px" :model="formLabelAlign">
        <el-row class="row-list" :gutter="20">
          <el-col :span="12"
            ><el-form-item label="付款類型">
              <el-input v-model="formLabelAlign.name"></el-input> </el-form-item
          ></el-col>
          <el-col :span="12"
            ><el-form-item label="支付類型">
              <el-input v-model="formLabelAlign.name"></el-input> </el-form-item
          ></el-col>
        </el-row>
        <el-row class="row-list" :gutter="20">
          <el-col :span="12"
            ><el-form-item label="交易編號">
              <el-input v-model="formLabelAlign.name"></el-input> </el-form-item
          ></el-col>
          <el-col :span="12"
            ><el-form-item label="推廣碼">
              <el-input v-model="formLabelAlign.name"></el-input> </el-form-item
          ></el-col>
        </el-row>
        <el-form-item label="備註">
          <el-input v-model="formLabelAlign.name"></el-input>
        </el-form-item>
      </el-form>

      <vue-dividing-line title="年級信息"></vue-dividing-line>
      <div>
        <el-table stripe :data="detail.grades" style="width: 100%;">
          <el-table-column prop="studentName" label="年級"> </el-table-column>
          <el-table-column prop="studentName" label="學生帳戶名稱">
          </el-table-column>
          <el-table-column prop="studentName" label="訂閱開始時間">
          </el-table-column>
          <el-table-column prop="studentName" label="訂閱結束時間">
          </el-table-column>
          <el-table-column prop="price" label="價格 ($)"> </el-table-column>
          <el-table-column prop="payPrice" label="實付價格"> </el-table-column>
        </el-table>
      </div>
      <div class="page-button">
        <el-button type="info">確定</el-button>
        <el-button type="success" @click="onBack">取消</el-button>
      </div>
    </div>
  </div>
</template>

<script>
import { getOrderDetail } from "@/api/order";
export default {
  props: {
    id: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      detail: {},
      formLabelAlign: {
        name: "",
        region: "",
        type: "",
      },
    };
  },
  created() {
    this.getOrderDetail();
  },
  methods: {
    onProgramText(id) {
      this.$router.push({ path: `/programme/${id}` });
    },
    getOrderDetail() {
      getOrderDetail(this.id).then((v) => {
        this.detail = v.data;
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.page-box {
  margin: 20px 0;
  background-color: #fff;
  padding: 20px;
}
.row-list {
  margin-bottom: 10px;
}
.page-button {
  text-align: center;
}
</style>